export enum IntegrationAccessTypes {
  MENU_API = 'menuApiAccess',
  ORDER_API = 'orderApiAccess',
  SFTP_INTEGRATION = 'sftpIntegrationAccess',
}
